import script from "./GuideComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./GuideComponent.vue?vue&type=script&setup=true&lang=js"

import "./GuideComponent.vue?vue&type=style&index=0&id=42e737dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42e737dd"]])

export default __exports__